import RenderData from "./components/render-data/renderData";

const App = () => {

  const reactContainer = document.querySelector('.block-list-fetch');
  let dataPath = reactContainer.getAttribute('data-path');
  let dataType = reactContainer.getAttribute('data-card-type');
    return(
        <div className={`countries-list content-${dataType}`}>
            <RenderData pathFech={dataPath} />
        </div>
    )
  };

const content = document.querySelector('.block-list-fetch');
ReactDOM.render(<App />, content);
